import { COMPLETE_ONBOARDING_STEP, RESET_ONBOARDING } from "./types";

const initialState = {};

export const onBoardingReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case COMPLETE_ONBOARDING_STEP:
      const completedSteps = state.completedSteps || [];
      completedSteps.push(payload);
      const uniqueCompletedSteps = [...new Set(completedSteps)];
      localStorage.setItem('completedSteps', JSON.stringify(uniqueCompletedSteps));
      return {   
        ...state,
        completedSteps: uniqueCompletedSteps,
       };
    case RESET_ONBOARDING:
      localStorage.removeItem('completedSteps');
      return {
        ...state,
        completedSteps: [],
      };

    default:
      return state;
  }
};
